import client from '../httpClient';

// common: /areas/{code} エリア一覧取得
const areaListApi = (code, params) => {
  const GET_AREA_LIST_URL = `/common/areas/${String(code)}`;
  return client.get(GET_AREA_LIST_URL, { params });
};

export default areaListApi;
